<template>
<div class="sz"  v-loading="loading">
<div class="contend" >
<div class="detialMsg">
  <div class="ownMsg">
    <el-card class="box-card">
  <div slot="header" class="clearfix">
    <span class="ku">基础信息</span>

  </div>
  <div class="text">
   <div class="basicPhoto">
     <img :src="basicPhoto?(imgUrl+basicPhoto):defaultImg" alt="">
   </div>
   <ul class="basicInfo">
     <li><span>姓名</span>:{{personName}}</li>
      <li style="color:red"><span>年龄</span>:{{GetAge(idCard)}}</li>
      <li style="color:red"><span>性别</span>:{{getSex(idCard)}}</li>
     <li><span>身份证号码</span>:<span class="idcc" id="danhao" @click="oCopy()">{{idCard}}</span></li>
     <li><span>手机号码</span>:{{telphone}}</li>
   </ul>
  </div>
</el-card>
  </div>
  <div class="photoList">
    <el-card class="box-card">
  <div slot="header" class="clearfix">
    <span class="ku2">身份证正反照片</span>
  </div>
  <div class="igcon">
   
   
      <div class="demo-image__preview" v-for="(item,index) in fontIdphoto" :key="index">
  <el-image 
    style="width: 100px; height: 100px"
    :src="imgUrl+item" 
    :preview-src-list="[imgUrl+item]">
  </el-image>
</div>
    
    <!-- <div class="iii">
      <el-image  :src="fontIdphoto?fontIdphoto:defaultImg" :preview-src-list="srcList" alt=""></el-image>
    </div>
    <div class="iii">
       <el-image :src="backIdphoto?backIdphoto:defaultImg" :preview-src-list="srcList" alt=""></el-image>
    </div> -->

  </div>
</el-card>
  </div>
  </div>

  <!-- <div class="ownMsg" style="width:99.5%">
    <el-card class="box-card">
  <div slot="header" class="clearfix">
    <span class="ku">待审核信息</span>

  </div>
  <div class="text">
   <div class="basicPhoto">
     <img :src="lbasicPhoto?(imgUrl+lbasicPhoto):defaultImg" alt="">
   </div>
   <ul class="basicInfo lbasicInfo">
     <li><span>姓名</span>:{{lpersonName}}</li>
      <li style="color:red"><span>年龄</span>:{{GetAge(lidCard)}}</li>
     <li><span>身份证号码</span>:{{lidCard}}</li>
     <li><span>手机号码</span>:{{ltelphone}}</li>
   </ul>
  </div>
</el-card>
  </div> -->

<div class="his">
  <p class="cler">历史记录</p>
  <div class="hiscont">
      <div class="demo-image__preview" v-for="(item,index) in featureDtoList" :key="index">
  <el-image 
    style="width: 100px; height: 100px"
    :src="imgUrl+item.pictureInfo" 
    :preview-src-list="[imgUrl+item.pictureInfo]">
  </el-image>
</div>
       <!-- <img  v-for="(item,index) in featureDtoList" :key="index" style="width: 100px; height: 100px" :src="imgUrl+item.pictureInfo"  alt=""> -->

  </div>
</div>
<div class="List">
    <el-card class="box-card">
  <div slot="header" class="clearfix">
    <span >认证列表</span>
  </div>
  <div class="text">
   <el-table
    :data="tableData"
    style="width: 100%"
    :cell-style="changeColor"
    stripe>
    <el-table-column label="选择" width="55">
            <template slot-scope="scope">
                <el-radio  v-model="tableRadio" @change="isChecked" :label="scope.row"><i></i></el-radio>
            </template>
        </el-table-column>
     <el-table-column
      prop="createtime"
      width="100"
      label="认证照片">
      <template slot-scope="scope">
        <el-popover
    placement="right"
    title=""
    trigger="hover">
                    <img slot="reference" :src="(imgUrl+scope.row.recordPhoto)||defaultImg" height="70"  class="head_pic">
                    <img :src="(imgUrl+scope.row.recordPhoto)"  height="400px"  class="head_pic"/>
                    </el-popover>
                </template>
    </el-table-column>
     <el-table-column
      prop="fromModel"
      label="设备来源">
    </el-table-column>
     <el-table-column
      prop="bakStr"
      label="比值">
    </el-table-column>
    <el-table-column
      prop="livescore"
      label="活体值">
    </el-table-column>
     <el-table-column
      prop="nowAddress"
      label="认证地点">
    </el-table-column>
     <el-table-column
      prop="createTime"
      label="认证时间">
    </el-table-column>
  </el-table>
  </div>
</el-card>
  </div>
    </div>
    <div class="sh">
     <el-button type="warning" @click="nopass" icon="el-icon-close">审核失败</el-button>
     <el-button type="danger" @click="police" :disabled="isDisabled" icon="el-icon-full-screen">公安比对</el-button>
      <el-button type="success" @click="pass" :disabled="isDisabled" icon="el-icon-check">审核通过</el-button>
     </div>
     <el-dialog
  title="审核失败原因"
  :visible.sync="dialogVisible"
  width="60%"

  >
   <el-select v-model="reson" placeholder="请选择失败原因" style="width:100%">
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>

  <span slot="footer" class="dialog-footer">
    <el-button @click="del">取 消</el-button>
    <el-button type="primary" @click="com">确 定</el-button>
  </span>
</el-dialog>
  </div>
</template>

<style lang='scss'>
.cler{
  padding: 4px;
  border-bottom: 1px solid #EBEEF5;
  font-size: 14px;
  margin:0;
 
}
.his{
  border:1px solid #EBEEF5;
  margin-bottom: 15px;
   box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}
.sh{
  margin: 40px
}
.idcc{
  cursor: pointer;
}
.hiscont{
  padding: 15px;
  display: flex;
}
.hiscont img{
  margin-right: 10px;
  display: inline;
}
.igcon{
 // display: flex;
 // overflow-x: scroll;
  //overflow: scroll;
  align-items: center;
  justify-content: space-around
}
.igcon .iii,.igcon .el-image{
  position: relative;
  width: 50px;
  height: 160px;
  overflow: visible !important
}
.igcon {
  display: flex;
  flex-wrap: wrap;
}
.demo-image__preview{
  width: 100px;
}
.el-image__inner{
 height: 100%;
 width: auto !important;
 position: absolute;
 right: 0;
 top: 0;
 z-index: 100;
}
.el-image-viewer__actions{
  z-index: 222;
}
.el-icon-circle-close{
  color: #fff
}
.el-icon-full-screen{
  display: none !important
}
// .sz .el-image__inner:hover{
//  transform: scale(3.0);
//  transform-origin: 100% 0
// }


.el-form-item__content{
  text-align: left
}
.detialMsg{
  margin-top: 20px;
  overflow:visible !important;
  .el-card{
  overflow:visible !important
}
  }
  .detialMsg:after{/*伪元素是行内元素 正常浏览器清除浮动方法*/
        content: "";
        display: block;
        height: 0;
        clear:both;
        visibility: hidden;
  }
  .el-card__header{
    padding: 5px 5px;
    text-align: left;
    font-size: 14px
  }
  .text {
    text-align: left;
    font-size: 14px;
    .basicPhoto,.basicInfo{
      float: left;
      list-style: none;
      padding: 0 0 0 10px;
      margin: 0
    }
    .basicInfo{
      li{
        font-size: 14px;
        margin-bottom: 5px
      }
    }
    .lbasicInfo{
      li{
        margin-bottom: 10px !important
      }
    }
    .basicPhoto{
      padding: 0;
      height: 150px;
      border: 1px solid gray;
      img{
        height: 100%
      }
    }


  }
 .el-card__header{
   height: 30px
 }
 .el-card__body{
   min-height: 160px
 }
.changeBasic{
  border: 1px solid lightgray;
  float: right;
  cursor: pointer;
}
.changeBasic:hover{
  color: #2782AF
}
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 100%;
  }
  .ownMsg{
    float: left;
    width: 49%;
    margin-bottom: 20px;
  }
  .photoList{
    float: right;
    margin-right: 2px;
    width: 49%;
    margin-bottom: 20px;
  }
  @media screen and (max-width:1200px) {
  .ownMsg{
    float: left;
    width: 100%
  }
  .photoList{
    float: left;
    width: 100%
  }
  }
.photoLiss{
width: 20%;
display: inline-block;
position: relative;
}
.photoLiss img{
width: 100%;


}
// .photoLiss img:hover{
// transform: scale(2.0);
//  transform-origin: 50% 0;
//  position: absolute;
// left: 0;
// top: -100px;
// z-index: 200;
// }
.List{
  .el-card__header{
    padding: 5px 5px;
    text-align: left;
    font-size: 14px
  }
}
.op{
  display: flex;
  align-items: center;
}
  .idc{
    width: 200px
  }
  .nam{
    margin-right: 20px
  }
  .ywtyoe{
    width: 200px;
    margin-left: 20px
  }
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
  .pone{
    margin-top: 40px
  }
  .el-timeline{
    padding-left: 20px
  }
  .add{
      margin-left: 20px
  }
</style>

<script>
import Axios from "axios"
import Cookies from "js-cookie";
import CryptoJS from 'crypto-js'
import { Loading } from 'element-ui';
import {listtown} from '../../utils/address'
import defaultImg from "../../assets/defaultPicture.jpg"
import formatDate from "../../utils/timeStr"
import {backType} from "../../utils/typeAuth"
  export default {

       data() {

      return {
         srcList: [

        ],
        isDisabled:true,
        tableRadio:"",
        isCover:true,//是否覆盖默认照片
        reson:"无身份证照片",
        options:[{
					label:"照片模糊",
					value:"照片模糊"
				},{
					label:"照片不合规",
					value:"照片不合规"
				},{
					label:"信息不匹配",
					value:"信息不匹配"
        },{
					label:"无身份证照片",
					value:"无身份证照片"
        },{
					label:"姓名与身份证不符",
					value:"姓名与身份证不符"
        }],
        loading:false,
				dialogVisible:false,
        data_state:'',
        ldata_state:'',
        fontIdphoto:'',
        featureDtoList:'',
        backIdphoto:'',
        defaultImg:defaultImg,
        basicPhoto:'',
        lbasicPhoto:'',
        loading:false,
        totals:0,
        isNew:'',
        lisNew:'',
        Page:1,
        idCard:'',
        personName:'',
        lidCard:'',
        lpersonName:'',
        operate_name:'',
        telphone:'',
        ltelphone:'',
        authAdress:'',
        tableData:[],
        imgUrl:"http://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/",
        idNo:'',

      }
    },
    methods: {
      changeColor(column){
       if(column.row.livescore<0.1){
         return "background:#F68B71"
       }else if(column.row.livescore>0.1&&column.row.livescore<0.5){
         return "background:#FDF5E6"
       }
      },
      oCopy(){
        var text =document.getElementById("danhao").innerText;
        var input = document.createElement('input');
        input.setAttribute('id', 'copyInput');
        input.setAttribute('value', text);
        document.getElementsByTagName('body')[0].appendChild(input);
        document.getElementById('copyInput').select();
        if (document.execCommand('copy')) {
              this.$message({
             type:"success",
             message:"身份证号码复制成功"
           })
        }
        document.getElementById('copyInput').remove();

      },
      //公安比对
      police(){
        this.loading=true
        this.$confirm('每个人每天只能进行2次公安比对,是否继续进行公安比对?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          let data={
            idCard:this.tableRadio.identityNumber,
            userName:this.tableRadio.personName,
            photo:this.tableRadio.recordPhoto
          }
          this.$api.getlist.police(data).then((res) => {
        this.loading=false
         if(res.code==200){
           this.$message({
             type:"success",
             message:"比对成功"
           })
           this.pass()
         }else{
            this.$message({
             type:"warning",
             message:res.describe
           })
         }
        }).catch((res) => {
          this.$message({
             type:"warning",
             message:"提交失败"
           })
          this.loading=false
        });

        }).catch(() => {
          this.loading=false
          this.$message({
            type: 'info',
            message: '已取消比对'
          });
        });
      },
      //选中
      isChecked(){
        this.isDisabled=false
        console.log(this.tableRadio)
      },
    getSex(UUserCard){
//获取性别
if (parseInt(UUserCard.substr(16, 1)) % 2 == 1) {
//男
return "男";
} else {
//女
return "女";
}
},
      GetAge(identityCard) {
    var len = (identityCard + "").length;
    if (len == 0) {
        return 0;
    } else {
        if ((len != 15) && (len != 18))//身份证号码只能为15位或18位其它不合法
        {
            return 0;
        }
    }
    var strBirthday = "";
    if (len == 18)//处理18位的身份证号码从号码中得到生日和性别代码
    {
        strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
    }
    if (len == 15) {
        strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
    }
    //时间字符串里，必须是“/”
    var birthDate = new Date(strBirthday);
    var nowDateTime = new Date();
    var age = nowDateTime.getFullYear() - birthDate.getFullYear();
    //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
    if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
},
      del(){
        this.dialogVisible=false
      },
      //审核失败
      com(){
        this.loading=true
       let data={
          identityNumber:this.Encrypt(this.idCard),
          match_state:2,
         // deptId:this.tableRadio.deptId,
          lib_id:this.tableRadio.lib_id,
          authTime:this.tableRadio.createTime,
          defaultPhoto:this.basicPhoto,
          operate:this.reson,
          id:this.tableRadio.id,
         // bak_int:this.isCover?1:0,
          verify_type:backType(this.$route.params.verify_types)
        }
 this.$api.getlist.authcheck(data).then((res) => {
        this.loading=false
         this.dialogVisible=false
         if(res.code==200){
           this.$message({
             type:"success",
             message:"提交成功"
           })
           this.$emit("closeTag",1)
            sessionStorage.removeItem("router")
         }else{

           this.$message({
             type:"warning",
             message:res.message
           })
         }
        }).catch((res) => {
          this.$message({
             type:"warning",
             message:"提交失败"
           })
          this.loading=false
        });
      },
      //审核成功
      pass(){
        console.log(this.tableRadio)
        this.loading=true
        console.log(this.isCover)
        let data={
          identityNumber:this.Encrypt(this.idCard),
          match_state:0,
          operate:'',
         // deptId:this.tableRadio.deptId,
          lib_id:this.tableRadio.lib_id,
          authTime:this.tableRadio.createTime,
          collectImg:this.tableRadio.recordPhoto,
          defaultPhoto:this.basicPhoto,
          id:this.tableRadio.id,
         // bak_int:this.isCover?1:0,
          verify_type:backType(this.$route.params.verify_types)
        }
 this.$api.getlist.authcheck(data).then((res) => {
        this.loading=false
         if(res.code==200){
           this.$message({
             type:"success",
             message:"审核成功"
           })
           //关闭标签
            this.$emit("closeTag",1)
            sessionStorage.removeItem("router")
         }else{

           this.$message({
             type:"warning",
             message:res.message
           })
         }
        }).catch((res) => {
           this.$message({
             type:"warning",
             message:"取消提交"
           })
          this.loading=false
        });
      },
      nopass(){
this.dialogVisible=true
      },
      current_change(ss){
         let data={
        idNo:this.Encrypt(this.lidCard),
        pageNum:ss,
        pageSize:10
      }
   this.$api.getlist.findByIdCard(data).then((res) => {
     if(res.code=200){
     this.personName=this.decrypt(res.data.personName)
     this.idCard=this.decrypt(res.data.identityNumber)
     this.telphone=res.data.telphone?this.decrypt(res.data.telphone):''
     this.basicPhoto=res.data.defaultPhoto
         let rest=JSON.parse(res.result.veriryMessageEntityList.list)
         
         for(let i in  rest){
         rest[i].match_state=rest[i].match_state==0?"认证成功":rest[i].match_state==2?"认证失败":rest[i].match_state==3?"审核中":""
         rest[i].fromModel=rest[i].fromModel==1?"安卓":rest[i].fromModel==2?"IOS":rest[i].fromModel==3?"安卓绿色通道":rest[i].fromModel==4?"IOS绿色通道":"其它"
       
         rest[i].createTime=formatDate(rest[i].createTime)
         }
          this.tableData=rest
      
          this.totals=res.result.veriryMessageEntityList.total
          }
        }).catch((res) => {
          this.loading=false
        });
      },
      //
      handleChange(){

      },
        handleDelete(g,h){

        },
        Encrypt(word) { //aes加密
				var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
				let srcs = CryptoJS.enc.Utf8.parse(word);
				let encrypted = CryptoJS.AES.encrypt(srcs, key, {
					mode: CryptoJS.mode.ECB,
					padding: CryptoJS.pad.Pkcs7
				});
				return encrypted.toString();
			},
         decrypt(word){
			    var key = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
			    var decrypt = CryptoJS.AES.decrypt(word, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
			    return CryptoJS.enc.Utf8.stringify(decrypt).toString();
      },
      decryptByDES(ciphertext) {
                var keyHex = CryptoJS.enc.Utf8.parse("abcdtnfo23255625");
                var decrypted = CryptoJS.DES.decrypt({
                    ciphertext: CryptoJS.enc.Base64.parse(ciphertext)
                }, keyHex, {
                    mode: CryptoJS.mode.ECB,
                    padding: CryptoJS.pad.Pkcs7
                });
                return decrypted.toString(CryptoJS.enc.Utf8);
            }
    },

    created(){
     
      let data;
     if(JSON.stringify(this.$route.params)!="{}"){
      sessionStorage.setItem("router",JSON.stringify(this.$route.params))

      this.lpersonName=this.$route.params.personName
      this.lidCard=this.$route.params.identityNumber
      this.ltelphone=this.$route.params.telphone
      this.lbasicPhoto=this.$route.params.recordPhoto
      this.ldata_state=this.$route.params.match_state
       data={
        idNo:this.Encrypt(this.lidCard),
        pageNum:1,
        id:this.$route.params.lib_id,
        pageSize:10
      }
      }else{
        let s=sessionStorage.getItem("router")
        if(s){
      s=JSON.parse(s)
     // this.backIdphoto=s.idcardBack
      this.lpersonName=s.personName
      this.lidCard=s.identityNumber
      this.ltelphone=s.telphone
      this.lbasicPhoto=s.recordPhoto
      this.ldata_state=s.match_state
     
      this.featureDtoList=s.featureDtoList
       data={
        idNo:this.Encrypt(this.lidCard),
        pageNum:1,
        id:s.lib_id,
        pageSize:10
      }
      }else{
         this.$emit("closeTag",1)
        // this.$router.push({
        //   name:"认证审核"
        // })

      }
      }

   this.$api.getlist.findByIdCard(data).then((res) => {
     this.personName=this.decrypt(res.data.personName)
      this.fontIdphoto=res.data.idCardFortImg

      //this.backIdphoto=res.data.idcardFront?(this.imgUrl+res.data.idcardBack):''
      // this.srcList= [this.fontIdphoto,this.backIdphoto]
      //     console.log(this.srcList)
      // //是否默认照片
      // if(this.fontIdphoto&&this.backIdphoto){
      //   this.isCover=true
      // }else{
      //   this.isCover=false
      // }
       this.featureDtoList=res.data.featureDtoList
       console.log(this.featureDtoList)
     this.idCard=this.decrypt(res.data.identityNumber)
     this.telphone=res.data.telphone?this.decrypt(res.data.telphone):''
     this.basicPhoto=res.data.defaultPhoto
         let rest=res.data.veriryMessageEntityList.list
         
         for(let i in  rest){
         rest[i].match_state=rest[i].match_state==0?"认证成功":rest[i].match_state==2?"认证失败":rest[i].match_state==3?"审核中":""
         rest[i].fromModel=rest[i].fromModel==1?"安卓":rest[i].fromModel==2?"IOS":rest[i].fromModel==3?"安卓绿色通道":rest[i].fromModel==4?"IOS绿色通道":"其它"
       rest[i].createTime=formatDate(rest[i].createTime)

         }
          this.tableData=rest
          this.totals=res.result.veriryMessageEntityList.total
        }).catch((res) => {
          this.loading=false
        });

    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Myvue/authVerifyDetial.vue